import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './fp-symbol-cell.js';

/**
 * Fiyat Tablosu — N sütunlu kart grid'i.
 *
 * Satır sayısı OTOMATİK: ceil(sembol / sütun) → hücreler ekranı doldurur, boş satır
 * kalmaz (eski sabit `rows` yok sayılır — kısa hücre/küçük yazı sorununu çözer).
 * `text_size` (auto/large/xlarge) → --fp-cell-scale ile yazı çarpanı (cell.css).
 */
@customElement('fp-symbol-grid')
export class FpSymbolGrid extends LitElement {
    @property({ type: Number }) columns = 3;
    @property({ type: Array }) symbols: string[] = [];
    @property({ type: Array }) show: string[] = ['bid', 'ask', 'direction'];
    @property({ type: String, attribute: 'text-size' }) textSize: 'auto' | 'large' | 'xlarge' = 'auto';
    @property({ type: String, attribute: 'name-style' }) nameStyle: 'plain' | 'band' = 'plain';

    createRenderRoot(): HTMLElement {
        return this;
    }

    private scale(): number {
        return this.textSize === 'large' ? 1.25 : this.textSize === 'xlarge' ? 1.5 : 1;
    }

    render() {
        if (this.symbols.length === 0) {
            return html`<div class="fp-empty">Bu ekran için henüz sembol seçilmedi.</div>`;
        }
        const cols = Math.min(6, Math.max(1, this.columns || 3));
        const MAX = 48;
        if (this.symbols.length > MAX) {
            console.warn(
                `[fp-symbol-grid] ${this.symbols.length} sembol seçili — ilk ${MAX} gösteriliyor, ` +
                `${this.symbols.length - MAX} sembol gizlendi (okunabilirlik için tabloyu bölün).`,
            );
        }
        const visible = this.symbols.slice(0, MAX);
        const rows = Math.max(1, Math.ceil(visible.length / cols));
        return html`
            <div
                class="fp-grid grid gap-2 w-full h-full p-2"
                style="
                    --fp-cell-scale: ${this.scale()};
                    grid-template-columns: repeat(${cols}, minmax(0, 1fr));
                    grid-template-rows: repeat(${rows}, minmax(0, 1fr));
                "
            >
                ${visible.map(
                    (s) => html`<fp-symbol-cell .symbol=${s} .show=${this.show} .nameStyle=${this.nameStyle}></fp-symbol-cell>`,
                )}
            </div>
        `;
    }
}
